import Group from 'components/utils/Group'
import React from 'react'
import AccommodationRoomDetailsList from './AccommodationRoomDetailsList'
import AccommodationAmenitiesAndPoliciesContent from 'components/OfferPage/Accommodation/AccommodationAmenitiesAndPoliciesContent'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import ImageGallery from 'components/Luxkit/Carousel/ImageGallery'
import { ImageParams } from 'components/Common/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'

const imageProps: ImageParams = {
  mobileAspectRatio: '16:8',
  tabletAspectRatio: '16:8',
  quality: 'good',
}

interface Props {
  roomPackage: App.HotelPackage
}

function AccommodationRoomDetailsModal(props: Props) {
  const { roomPackage } = props

  return <ModalBase>
    <ModalHeader title={roomPackage.roomType.name} />
    <ModalBody>
      {!!roomPackage.roomType.images.length && <ModalContent flush>
        <ImageGallery
          images={roomPackage.roomType.images}
          imageParams={imageProps}
        />
      </ModalContent>}
      <ModalContent>
        <Group direction="vertical" gap={20}>
          <VerticalSpacer gap={16}>
            <BodyTextBlock variant="large">{roomPackage.roomType.description}</BodyTextBlock>
            <AccommodationRoomDetailsList roomPackage={roomPackage} />
          </VerticalSpacer>
          <div>
            <AccommodationAmenitiesAndPoliciesContent roomPackage={roomPackage} />
          </div>
        </Group>
      </ModalContent>
    </ModalBody>
  </ModalBase>
}

export default AccommodationRoomDetailsModal
